import { useEffect } from 'react';
import { useGetConversationById, useSetConversation } from 'hooks/business/lruConversation';
import { useSetConversationIdListValue } from 'hooks/business/conversation';
import { useOpenConversation } from 'hooks/business/conversationsHooks/useOpenConversation';
import { useSetSearchMsgSelectedSendTime } from 'hooks/business/searchMsgSelectedMsg';
import { getTalkInfo } from 'services/api/conversation.convList';

interface UseOpenConversationFromQueryParams {
  category: 'mine' | 'all';
  conversationIdFromQuery?: string;
}

export const useOpenConversationFromQuery = ({
  category,
  conversationIdFromQuery,
}: UseOpenConversationFromQueryParams) => {
  const getConversationById = useGetConversationById();
  const setConversation = useSetConversation();
  const setConversationIdList = useSetConversationIdListValue();
  const setSearchMsgSelectedSendTime = useSetSearchMsgSelectedSendTime();
  const openConversation = useOpenConversation();

  useEffect(() => {
    if (!conversationIdFromQuery || !/^\d+$/.test(conversationIdFromQuery)) return;

    const cachedConversation = getConversationById(conversationIdFromQuery);
    const loader = cachedConversation
      ? Promise.resolve(cachedConversation)
      : getTalkInfo({ conversationId: conversationIdFromQuery, suTalkMode: category === 'all' });

    loader
      .then((conversation) => {
        setConversation(conversationIdFromQuery, conversation);
        setConversationIdList((prev) =>
          prev.includes(conversationIdFromQuery) ? prev : [...prev, conversationIdFromQuery],
        );
        setSearchMsgSelectedSendTime({ msgId: '', sendTime: '' });
        openConversation(conversation, { category });
      })
      .catch((error) => {
        console.error('Failed to open conversation from query:', error);
      });
  }, [
    category,
    conversationIdFromQuery,
    getConversationById,
    openConversation,
    setConversation,
    setConversationIdList,
    setSearchMsgSelectedSendTime,
  ]);
};
